import React from "react";
import { logErrorMessage } from "@wss/error-tracking";

interface Params {
  email: string;
  itemNumber: string;
  recaptchaToken: string;
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>;
}

const request = async ({
  email,
  itemNumber,
  recaptchaToken,
  setErrorMessage,
}: Params) => {
  const errorMessage = "There was an error sending email. Please try again.";

  try {
    const body = {
      itemNumber,
      emailAddress: email,
      isOutlet: itemNumber.includes("outlet"),
      reCaptchaToken: recaptchaToken,
    };

    const response = await fetch(
      "/product-promotion/send-product-price-discount-email",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
        credentials: "include",
      },
    );

    if (!response.ok) {
      setErrorMessage(errorMessage);
    }
  } catch (error) {
    setErrorMessage(errorMessage);
    logErrorMessage(error, "info");
  }
};

export default request;
